import React from 'react'
import { combineClasses } from 'utils/combineClasses'

export const PlanDinnerDayName: React.FC<{day:string, isActive: boolean}> = ({day, isActive}) => {
  return (
    <p className={combineClasses("text-[14px] leading-[18px] font-medium text-primary cursor-pointer", isActive ? '' : "line-through opacity-50")} >{day}</p>
  )
}
